import { render, staticRenderFns } from "./toolStopRegist.vue?vue&type=template&id=b775f2cc&scoped=true"
import script from "./toolStopRegist.vue?vue&type=script&lang=js"
export * from "./toolStopRegist.vue?vue&type=script&lang=js"
import style0 from "./toolStopRegist.vue?vue&type=style&index=0&id=b775f2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b775f2cc",
  null
  
)

export default component.exports